import app from "../data/base";

async function loadUtenti(idutente) {
  try{
    const response = await app.methods.callserver('api/admin/user' + (idutente ? '/'+idutente : ''), 'GET', null, null, true);
    return await response.json();
  }catch (e) {
    console.error(e);
  }
}

export const utenti = {
  methods: {
    loadUtenti
  }
}
